import * as React from "react";

export default class extends React.Component<any> {
  employmentClick(e: any, employmentType: string) {
    e.preventDefault();
    this.props.setEmploymentType(employmentType);
  }

  render() {
    return (
      <div>
        <h1>The Future Workforce: How prepared are you and your business?</h1>
        <img src="/images/woman-phone.png" width="500" />
        <p>
          UK workers are set to experience more changes in the next decade than
          any other: This quiz reveals the emerging workforce cultures of the
          future.
        </p>

        <section className="intro__choice">
          <div>
            <h2>Employee?</h2>
            <p>Discover which future workforce culture you identify with.</p>

            <a
              href="#"
              role="button"
              onClick={e => this.employmentClick(e, "employee")}
            >
              Take me to the quiz
            </a>
          </div>

          <div>
            <h2>Employer?</h2>
            <p>How prepared is your business for the future workforce?</p>

            <a
              href="#"
              role="button"
              onClick={e => this.employmentClick(e, "employer")}
            >
              Take me to the quiz
            </a>
          </div>
        </section>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Intro.tsx